module.exports = __webpack_public_path__ + "img/icon-home-ev-04.2632d9bd.jpg";